<!--
  @Description 问题汇总选择框
  @Date 2022-03-22
  @Author liushuo
-->
<template>
  <vxe-modal
    v-model="formVisible"
    title="问题汇总选择框"
    width="70%"
    height="80%"
    @show="showWindows"
    destroy-on-close
  >
    <div class="top-box">
      <div class="search-dv">
        <el-form
          :model="searchForm"
          ref="FormRef"
          :validate-on-rule-change="false"
          :rules="rules"
          size="mini"
          @keyup.enter.native="confirmSearch"
        >
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="问题编号" prop="numList">
                <el-input
                  v-model="searchForm.numList"
                  autocomplete="off"
                  placeholder="可填写多个，按逗号分隔"
                  clearable
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="页面" prop="vuePath">
                <el-input
                  v-model="searchForm.vuePath"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  clearable
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
              ><el-form-item label="提出日期从" prop="createDateFrom">
                <el-date-picker
                  v-model="searchForm.createDateFrom"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="提出日期至" prop="createDateTo">
                <el-date-picker
                  v-model="searchForm.createDateTo"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="bts-box">
        <el-button type="default" size="mini" @click="confirmSearch"
          >查询</el-button
        >
        <el-button type="warning" size="mini" @click="resetSearch"
          >重置</el-button
        >
        <!-- <el-button type="primary" size="mini" @click="Sure">选中</el-button> -->
        <el-button type="primary" size="mini" @click="SureAndClose"
          >选中并关闭</el-button
        >
      </div>
    </div>
    <div class="main-box">
      <!-- 数据展示区域 -->
      <vxe-grid
        border
        resizable
        size="mini"
        :column-config="{ minWidth: '80px' }"
        :columns="tableColumns"
        :height="scrollerHeight"
        ref="xTable"
        :mouse-config="{ area: true, extension: true }"
        highlight-hover-row
        highlight-current-row
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true,
        }"
        :data="tableData"
        @checkbox-change="handleChangeCheck"
        @checkbox-all="handleChangeCheck"
      >
        <!-- @page-change="handlePageChange"
        :seq-config="{
          startIndex: (tablePage.currentPage - 1) * tablePage.pageSize,
        }"
        :pager-config="tablePage" -->
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script>
// import { tableConfig } from '@/public/params/global.js'
export default {
  name: 'QuestionSelect',
  props: {
    parentObj: Object,
    menuArgs: {
      type: String,
      default: '',
    },
    sqlTitle: {
      type: String,
      default: 'select',
    },
    // 当前主表标识
    mainID: {
      type: Number,
      default: -1,
    },

    Authority: {},
  },
  data() {
    return {
      searchForm: {
        exceptID: '',
        numList: '',
        menuArgs: '',
        vuePath: '',
        createDateFrom: '',
        createDateTo: '',
      },
      rules: {
        createDateFrom: [
          {
            validator: this.checkDateMin,
            trigger: 'change',
          },
        ],
        createDateTo: [
          {
            validator: this.checkDateMax,
            trigger: 'change',
          },
        ],
      },
      // 是否显示
      formVisible: false,
      tableData: [],
      // 查找框是否显示
      // searchFormVisible: true,
      // 动态查找获取条件
      // searchVuePath: 'TXDeptFileList',
      // 动态查找条件
      searchObjects: [],
      // 查找条件是否全部返回
      fullSearchFilter: false,
      // tablePage: {
      //   total: 0,
      //   currentPage: 1,
      //   pageSize: tableConfig.defaultPageSize,
      //   align: 'right',
      //   pageSizes: tableConfig.pageSizes,
      //   layouts: [
      //     'Sizes',
      //     'PrevJump',
      //     'PrevPage',
      //     'Number',
      //     'NextPage',
      //     'NextJump',
      //     'FullJump',
      //     'Total',
      //   ],
      //   perfect: true,
      // },
      // 已选中数据
      selectRecords: [],
      // 当选行
      selectRow: null,
      // 列设置
      tableColumns: [],
      ComBoxItems: {
        menuArgs: '',
      },
    }
  },
  methods: {
    // 初始化
    InitColumn() {
      this.tableColumns = [
        { type: 'seq', fixed: 'left', width: '50' },
        { type: 'checkbox', align: 'center', width: '40' },
        { field: 'id', title: '标识', visible: false },
        {
          title: '问题编号',
          width: 55,
          field: 'num',
          filters: [{ data: { val1: '', val2: '' } }],
          filterRender: { name: 'FilterInputRange' },
        },
        {
          title: '系统版本',
          width: 70,
          field: 'productionVersion',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '模块',
          width: 90,
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '页面',
          width: 90,
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '问题内容',
          field: 'content',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' },
        },
        {
          title: '紧急',
          width: 40,
          field: 'isPriority',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '类型',
          width: 35,
          field: 'type',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '提出人',
          width: 60,
          field: 'createtor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '前端研发',
          width: 70,
          field: 'frontEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '后端研发',
          width: 70,
          field: 'backEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '技术测试',
          width: 70,
          field: 'techTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
        {
          title: '业务测试',
          width: 70,
          field: 'businessTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: '',
              },
            },
          ],
          filterRender: { name: 'FilterExtend' },
        },
      ]
    },
    showWindows() {
      this.initData()
      this.initSearchForm()
      // this.BindComBox()
      this.InitColumn()
    },
    // // 绑定下拉框
    // async BindComBox() {
    //   this.ComBoxItems.menuArgs = []
    //   const { data: selectRes } = await this.$http.get(
    //     '/Common/BMenuGroup/select-item'
    //   )
    //   if (selectRes.isSuccess) {
    //     for (let item of selectRes.data) {
    //       switch (item.code) {
    //         case 'ProductionType':
    //           this.ComBoxItems.menuArgs.push(item)
    //           break
    //       }
    //     }
    //   }
    // },
    // 绑定数据
    initData() {
      this.selectRecords = []
      this.searchObjects = []
      this.tableData = []
    },
    initSearchForm() {
      this.searchForm = {
        // 排除下发流程单据标识
        exceptID: this.mainID,
        numList: '',
        // 产品类型
        menuArgs: this.menuArgs,
        vuePath: '',
        createDateFrom: '',
        createDateTo: '',
      }
    },
    SureAndClose() {
      this.Sure()
      this.formVisible = false
    },
    // 确认返回
    Sure() {
      // if (this.selectRow !== null) {
      //   this.selectRecords.push(this.selectRow)
      // }
      const selectRecords = this.$refs.xTable.getCheckboxRecords(true)
      this.$emit('sureHandle', selectRecords)
    },
    resetSearch() {
      this.initSearchForm()
    },
    // 确认查询
    async confirmSearch() {
      this.validEnter().then(async (result) => {
        if (result) {
          this.list()
        }
      })
    },
    // 校验
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        (res) => {
          flag = res
        },
        (err) => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 获取数据
    async list() {
      let form = this.removeObjectNull(this.searchForm)

      const { data: res } = await this.$http.post(
        '/Common/YKIssuedFlow/select',
        form
      )
      if (res.isSuccess) {
        this.tableData = res.data
      } else {
        this.$message.error(res.errorMessage)
        this.tableData = []
      }
    },

    // 验证日期区间
    checkDateMin() {
      return new Promise((resolve, reject) => {
        var minDate = new Date(this.searchForm.createDateFrom)
        var maxDate = new Date(this.searchForm.createDateTo)
        if (minDate.getTime() > maxDate.getTime()) {
          reject(new Error('截止日期不能早于起始日期'))
        } else {
          resolve()
        }
      })
    },
    // 验证日期区间
    checkDateMax() {
      return new Promise((resolve, reject) => {
        var minDate = new Date(this.searchForm.createDateFrom)
        var maxDate = new Date(this.searchForm.createDateTo)
        if (minDate.getTime() > maxDate.getTime()) {
          reject(new Error('截止日期不能早于起始日期'))
        } else {
          resolve()
        }
      })
    },
    // 获取选择
    handleChangeCheck({ records }) {
      // this.selectRecords = this.selectRecords.filter((item) => {
      //   return item.pageIndex !== this.tablePage.currentPage
      // })
      records.forEach((item) => {
        let record = { ...item }
        // record['pageIndex'] = this.tablePage.currentPage
        this.selectRecords.push(record)
      })
    },
  },
  computed: {
    scrollerHeight() {
      if (this.formVisible) {
        return this.$store.state.clientHeight * 0.8 - 180 + 'px'
      } else {
        return '100px'
      }
    },
  },
}
</script>

<style lang="less" scoped>
@searchDvHeight: 120px;
@buttonDvHeight: 40px;
.top-box {
  width: 100%;
}
.search-dv {
  height: 60px;
  width: 100%;
}
.bts-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}
.main-box {
  height: calc(80vh - 200px);
  width: 100%;
}
</style>
